import { type Routes } from '@angular/router';
import { BaseLayoutComponent } from './layout/base-layout/base-layout.component';
import { UserHomeComponent } from './views/user-home/user-home.component';
import { AdminActivateGuard } from './guards/admin-activate.guard';
import { authGuard } from './guards/auth-activate.guard';
import { requiredActionsGuard } from './guards/required-actions.guard';

import { DefenseSpendingActivateGuard } from './guards/defense-spending-activate.guard';
import { UserHome2Component } from './views/user-home2/user-home2.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/app',
    pathMatch: 'full',
  },
  {
    path: 'app_redirect',
    loadComponent: () => import('./views/app-redirect/app-redirect.component').then(m => m.AppRedirectComponent),
  },
  {
    path: 'landing',
    loadChildren: () => import('./views/landing/landing.routes').then(m => m.LANDING_ROUTES),
  },
  {
    path: 'sign-up',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./views/auth/login-supabase/login-supabase.component').then(m => m.LoginSupabaseComponent),
  },
  {
    path: 'invite',
    loadComponent: () => import('./views/accept-invite/accept-invite.component').then(m => m.AcceptInviteComponent),
  },
  {
    path: 'callback',
    loadComponent: () => import('./views/auth/callback-supabase/callback-supabase.component').then(m => m.CallbackSupabaseComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./views/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    canActivate: [authGuard],
  },
  {
    path: 'select-workspace',
    loadComponent: () => import('./views/select-workspace/select-workspace.component').then(m => m.SelectWorkspaceComponent),
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./views/contact-us/contact-us.component').then(m => m.ContactUsComponent),
  },
  {
    path: 'app',
    component: BaseLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [requiredActionsGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        // component: UserHomeComponent,
        component: UserHome2Component,
      },
      {
        path: 'onboarding',
        loadComponent: () => import('./views/onboarding-dynamic/onboarding-dynamic.component').then(m => m.OnboardingDynamicComponent),
      },
      {
        path: 'checkout-result',
        loadComponent: () => import('./views/checkout-result/checkout-result.component').then(m => m.CheckoutResultComponent),
        data: { breadcrumb: 'Checkout result' }
      },
      {
        path: 'ws',
        children: [
          {
            path: '',
            redirectTo: 'select-workspace',
            pathMatch: 'full'
          },
          {
            path: 'select-workspace',
            loadComponent: () => import('./views/select-workspace/select-workspace.component').then(m => m.SelectWorkspaceComponent),
          },
          {
            path: ':workspaceId',
            loadChildren: () => import('./views/workspace/workspace.routes').then(m => m.WORKSPACE_ROUTES),
          },
        ]
      },
      {
        path: 'tech-reports',
        loadChildren: () => import('./views/tech-reports/tech-reports.routes').then(m => m.TECH_REPORTS_ROUTES),
      },
      {
        path: 'defense_paywall',
        data: { breadcrumb: 'Paywall' },
        loadComponent: () => import('./views/defense-bd/defence-db-paywall/defence-db-paywall.component').then(m => m.DefenceDbPaywallComponent),
      },
      {
        path: 'support',
        data: { breadcrumb: 'Support' },
        loadComponent: () => import('./views/support/support.component').then(m => m.SupportComponent),
      },
      {
        path: 'contact-us',
        data: { breadcrumb: 'Contact Us' },
        loadComponent: () => import('./views/contact-us/contact-us.component').then(m => m.ContactUsComponent),
      },
      {
        path: 'billing',
        data: { breadcrumb: 'Billing' },
        loadChildren: () => import('./views/billing/billing.routes').then(m => m.BILLING_ROUTES),
      },
      {
        path: 'organizations',
        loadChildren: () => import('./views/organizations/organizations.routes').then(m => m.ORGANIZATIONS_ROUTES),
      },
      {
        path: 'usage',
        data: { breadcrumb: 'Usage' },
        loadChildren: () => import('./views/usage/usage.routes').then(m => m.USAGE_ROUTES),
      },
      {
        path: 'settings',
        data: { breadcrumb: 'Settings' },
        loadChildren: () => import('./views/settings/settings.routes').then(m => m.SETTINGS_ROUTES)
      },
      {
        path: 'dev',
        loadChildren: () => import('./views/dev/dev.routes').then(m => m.DEV_ROUTES)
      },
      {
        path: 'admin',
        canActivate: [AdminActivateGuard],
        loadChildren: () => import('./views/admin/admin.routes').then(m => m.ADMIN_ROUTES),
      },
    ]
  },
  {
    path: '**',
    redirectTo: '/app/home',
    pathMatch: 'full'
  }
];